export const GET_HEADLINES_REQUEST = 'GET_HEADLINES_REQUEST';
export const GET_HEADLINES_SUCCESS = 'GET_HEADLINES_SUCCESS';

export const DELETE_HEADLINE_REQUEST = 'DELETE_HEADLINE_REQUEST';
export const DELETE_HEADLINE_SUCCESS = 'DELETE_HEADLINE_SUCCESS';
